// frontend/src/components/OptionalAnalyticsTracker.jsx
import {
  useEffect,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";

import { useAuth } from "../../AuthContext";

import {
  clearConsentCache,
} from "../../lib/legal/consent";

import {
  clearOptionalAnalyticsStorage,
  installOptionalAnalyticsRuntime,
  recordOptionalAnalyticsEvent,
} from "../../lib/analytics/optionalAnalytics";

export default function OptionalAnalyticsTracker() {
  const location =
    useLocation();

  const {
    user,
    session,
    loading,
  } = useAuth();

  const lastTrackedPathRef =
    useRef("");

  /*
   * Do not install the optional analytics
   * runtime until authentication has been
   * restored and a valid session exists.
   */
  useEffect(() => {
    if (
      loading ||
      !user?.id ||
      !session?.access_token
    ) {
      return undefined;
    }

    return installOptionalAnalyticsRuntime();
  }, [
    loading,
    user?.id,
    session?.access_token,
  ]);

  useEffect(() => {
    if (loading) {
      return;
    }

    if (
      !user?.id ||
      !session?.access_token
    ) {
      lastTrackedPathRef.current =
        "";

      clearConsentCache();

      clearOptionalAnalyticsStorage();

      return;
    }

    const pagePath =
      location.pathname;

    if (
      !pagePath ||
      lastTrackedPathRef.current ===
        pagePath
    ) {
      return;
    }

    lastTrackedPathRef.current =
      pagePath;

    recordOptionalAnalyticsEvent(
      "page_view",
      {
        route_type:
          pagePath.startsWith(
            "/play/"
          )
            ? "learning"
            : pagePath.startsWith(
                  "/profile"
                )
              ? "profile"
              : pagePath.startsWith(
                    "/resources"
                  )
                ? "resources"
                : "application",
      },
      {
        pagePath,
      }
    ).catch((error) => {
      /*
       * Unexpected analytics errors may
       * still be useful during development.
       * Authentication failures are handled
       * inside hasMyConsent().
       */
      console.error(
        "Optional page analytics failed:",
        error
      );
    });
  }, [
    loading,
    user?.id,
    session?.access_token,
    location.pathname,
  ]);

  return null;
}